import './Typography.scss';
import React from 'react';

const variantElement = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'p',
  subtitle2: 'p',
  body1: 'p',
  body2: 'p',
  caption: 'span',
};

const spacingKeys = {
  mt: 'marginTop',
  mb: 'marginBottom',
};

const toSpacing = (value) => (typeof value === 'number' ? value * 8 : value);

const normalizeSx = (sx) => {
  if (!sx || Array.isArray(sx) || typeof sx !== 'object') {
    return sx;
  }

  return Object.entries(sx).reduce((styles, [key, value]) => {
    if (key.startsWith('&')) {
      return styles;
    }

    styles[spacingKeys[key] || key] = spacingKeys[key] ? toSpacing(value) : value;
    return styles;
  }, {});
};

function Typography({
  children,
  variant = 'body1',
  component,
  color,
  align,
  gutterBottom = false,
  className = '',
  style,
  sx,
  mt,
  mb,
  ...rest
}) {
  const Element = component || variantElement[variant] || 'p';
  const typographyClassName = [
    'custom-typography',
    variant ? `custom-typography--${variant}` : '',
    color ? `custom-typography--${String(color).replace('.', '-')}` : '',
    align ? `custom-typography--align-${align}` : '',
    gutterBottom ? 'custom-typography--gutter-bottom' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <Element
      className={typographyClassName}
      style={{ marginTop: toSpacing(mt), marginBottom: toSpacing(mb), ...normalizeSx(sx), ...style }}
      {...rest}
    >
      {children}
    </Element>
  );
}

export default Typography;
